module.exports = __webpack_public_path__ + "static/IMG_0380-1500x1125-af0be610ddbf039710b927eb377f7909.jpg";